import { Container, Typography } from '@design-system';
import React, { useId } from 'react';
import './Checkbox.scss';

export type CheckboxProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string;
    disabled?: boolean;
    success?: boolean;
    cross?: boolean;
    neutral?: boolean;
    className?: string;
    forcedCenter?: boolean;
};

export const Checkbox: React.FC<CheckboxProps> = ({
    checked,
    onChange,
    label,
    success,
    cross,
    neutral,
    disabled,
    className,
    forcedCenter
}) => {
    const id = useId();

    return (
        <Container padding="none" className={`checkbox-container ${className} ${forcedCenter ? 'forced-center' : ''}`}>
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={() => onChange(!checked)}
                className={success ? 'success' : cross ? 'cross' : neutral ? 'neutral' : ''}
                disabled={disabled}
            />
            <label htmlFor={id}>
                <Typography intrinsic="p" variant="secondary" color={disabled ? 'grey' : 'marine'}>
                    {label}
                </Typography>
            </label>
        </Container>
    );
};
